module.exports = __webpack_public_path__ + "img/10-10.ce77ab08.jpeg";